import { config } from '../../config/config';

const verifyChainConfig = (
    chainId: number | undefined
): chainId is keyof typeof config.addresses => {
    if (!chainId) {
        throw new Error('ChainID is not defined');
    }

    if (!Object.keys(config.addresses).includes(chainId.toString())) {
        throw new Error('Unsupported ChainID');
    }

    return true;
};

export default verifyChainConfig;
